import { Auth, AuthStateType } from '@scope/scope-one-common/types/auth';
import { LocalStorage } from '@scope/scope-one-common/utils/localStorage';

export const loadState = () => {
  try {
    const { type, data } = LocalStorage.getAuth();

    if (data === null) {
      return undefined;
    }

    return {
      auth: {
        isPending: false,
        type,
        data,
        error: null,
      },
    };
  } catch (err) {
    return undefined;
  }
};

export const saveState = (state: Record<string, unknown>, type: AuthStateType) => {
  try {
    if (state) {
      LocalStorage.setAuth(state as Auth, type);
    } else {
      LocalStorage.clearAuth();
    }
  } catch (err) {
    throw new Error(err as string);
  }
};

export const saveOnboardingState = (done: boolean) => {
  try {
    localStorage.setItem('scopeOne-onboardingDone', JSON.stringify(done));
  } catch (err) {
    throw new Error(err as string);
  }
};

export const loadOnboardingState = (): boolean => {
  try {
    return !!localStorage.getItem('scopeOne-onboardingDone');
  } catch (err) {
    throw new Error(err as string);
  }
};

export const saveWhatsNewReadState = (read: Array<string>) => {
  try {
    localStorage.setItem('scopeOne-whatsNew-readIds', JSON.stringify(read));
  } catch (err) {
    throw new Error(err as string);
  }
};

export const loadWhatsNewReadState = (): Array<string> => {
  try {
    const localData = localStorage.getItem('scopeOne-whatsNew-readIds') || '[]';
    try {
      return JSON.parse(localData);
    } catch (error) {
      return [];
    }
  } catch (err) {
    throw new Error(err as string);
  }
};

export const localStorageBookmark = 'bookmarked-home';

export const setBookmark = (homeAddress: string) =>
  localStorage.setItem(localStorageBookmark, homeAddress);

export const getBookmark = () => localStorage.getItem(localStorageBookmark);
